import { FC } from 'react';
import { MenuItem, Select, SelectChangeEvent, styled } from '@mui/material';
import { FocusTheme } from '../configs/theme';
import PolarisIcon from '../../_common/PolarisIcon';

type SelectDropdownControlProps = {
  minWidth?: number;
  onChange: (value: string) => void;
  options: string[];
  value: string;
};

type DropdownIconProps = {
  className?: string;
};

const DropdownIcon: FC<DropdownIconProps> = ({ className }) => (
  <DropdownIconWrapper className={className}>
    <PolarisIcon icon="down" width={12} />
  </DropdownIconWrapper>
);

const SelectDropdownControl: FC<SelectDropdownControlProps> = ({ minWidth, onChange, options, value }) => {
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    onChange(event.target.value as string);
  };

  return (
    <StyledSelect value={value} onChange={handleChange} IconComponent={DropdownIcon} $minWidth={minWidth}>
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </StyledSelect>
  );
};

export default SelectDropdownControl;

const DropdownIconWrapper = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const StyledSelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== '$minWidth'
})<{ $minWidth?: number }>`
  align-items: center;
  background: ${({ theme }) => (theme as FocusTheme).palette.background.paper};
  border: 1px solid ${({ theme }) => (theme as FocusTheme).palette.neutral[100]};
  border-radius: 4px;
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[10]};
  display: flex;
  height: 39px;
  min-width: ${({ $minWidth }) => `${$minWidth ?? 94}px`};

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiSelect-icon {
    color: ${({ theme }) => (theme as FocusTheme).palette.neutral[30]};
    pointer-events: none;
  }
`;
